<div class="export-panel" [class.export-panel--expanded]="isExpanded()">
  <!-- Collapsed Badge -->
  @if (!isExpanded()) {
    <button
      class="export-panel__badge"
      (click)="toggleExpanded()"
      [matBadge]="activeCount()"
      matBadgeColor="warn"
      [matBadgeHidden]="activeCount() === 0"
    >
      <mat-icon>cloud_upload</mat-icon>
      <span class="export-panel__label">{{ 'dataExport.exports' | translate }}</span>
    </button>
  } @else {
    <!-- Expanded Panel -->
    <div class="export-panel__container">
      <div class="export-panel__header">
        <div class="export-panel__title">
          {{ 'dataExport.activeExports' | translate }}
          <span class="export-panel__count" [matBadge]="activeCount()" matBadgeColor="warn">
          </span>
        </div>
        <button
          mat-icon-button
          class="export-panel__close"
          (click)="toggleExpanded()"
          [title]="'dataExport.collapsePanel' | translate"
        >
          <mat-icon>close</mat-icon>
        </button>
      </div>

      @if (activeJobs().length === 0) {
        <div class="export-panel__empty">
          <p>{{ 'dataExport.noActiveExports' | translate }}</p>
        </div>
      } @else {
        <cdk-virtual-scroll-viewport itemSize="220" class="export-panel__list">
          @for (job of activeJobs(); track job.jobOid; let i = $index) {
            <div class="export-panel__item">
              <xemex-export-job-card [job]="job" />
            </div>
          }
        </cdk-virtual-scroll-viewport>
      }

      <div class="export-panel__footer">
        <small class="export-panel__status">
          @if (isPollingActive()) {
            {{ 'dataExport.refreshing' | translate: { interval: getPollIntervalDisplay() } }}
          } @else {
            {{ 'dataExport.pollingStopped' | translate }}
          }
        </small>
      </div>
    </div>
  }
</div>
